import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/svg/kaba-icon-black-and-white.svg")